import { render, staticRenderFns } from "./WidgetContents.html?vue&type=template&id=207cb677&scoped=true&external"
import script from "./WidgetContents.ts?vue&type=script&lang=ts&external"
export * from "./WidgetContents.ts?vue&type=script&lang=ts&external"
import style0 from "./WidgetContents.css?vue&type=style&index=0&id=207cb677&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207cb677",
  null
  
)

export default component.exports